module.exports = __webpack_public_path__ + "static/media/ResumeMarch5.027135f2.pdf";